import { SidebarProvider } from "@/components/ui/sidebar.tsx";
import { MenuSideBar } from "@/components/sidebar/pc-menu-sidebar.tsx";
import { Header } from "@/components/header";
import { Outlet } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile.ts";

export const AdminLayout = () => {
  const isMobile = useIsMobile();
    return (
          <SidebarProvider>
            {/* sidebar*/}
            {!isMobile && <MenuSideBar />}
              {/* main content */}
              <main className="relative w-full h-dvh overflow-hidden">
                <div className="h-full flex flex-col">
                  <Header />
                  {/* page content */}
                  <div
                    id="scroll-container"
                    className="flex-1 h-full bg-grayscale-5 overflow-y-auto"
                  >
                    <Outlet />
                  </div>
                </div>
              </main>
          </SidebarProvider>
    )
}